import { policies } from '../constants/policies'

export * from './selection'
export * from './shop'

// TODO: Need to supplement icon & document link
export default {
  name: 'OMC',
  prefix: 'omc',
  shortName: 'OMC',
  icon: 'fas fa-database',
  description: 'Order Management Center.',
  policy: policies.VISIT_OMC_APP,
  ns: 'OMC',
  document: '',
  isMoveToNewSite: false
}
